import { render } from "./User.vue?vue&type=template&id=65e08710&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-65e08710"

export default script